import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

import Information from '@/components/information'
import SecuritySetting from '@/components/securitySetting'
import OperationLog from '@/components/operationLog'
import VisitLog from '@/components/visitLog'
import LogonAccount from '@/components/logonAccount'
import UpdatePassword from '@/components/updatePassword'
import BindingCellPhone from '@/components/bindingCellPhone'
import SetInsurance from '@/components/setInsurance'
// import BindingOtp from '@/components/BindingOtp'

import SettingHome from '@/components/settingHome'
import ResetPassword from '@/components/ResetPassword'
import RetrievePassword from '@/components/RetrievePassword'

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        // name: 'SafeHome',
        component: Home,
        children: [
            {
                path: '/information',
                name: 'information',
                component: Information
            }, {
                path: '/securitySetting',
                // name: 'securitySetting',
                component: SecuritySetting,
                children: [{
                    path: '/',
                    name: 'settingHome',
                    component: SettingHome
                }, {
                    path: '/updatePassword',
                    name: 'updatePassword',
                    component: UpdatePassword
                }, {
                    path: '/bindingCellPhone',
                    name: 'bindingCellPhone',
                    component: BindingCellPhone
                }, 
                // {
                //     path: '/settingHome',
                //     name: 'settingHome',
                //     component: SettingHome
                // }, 
                {
                    path: '/setInsurance',
                    name: 'setInsurance',
                    component: SetInsurance
                }]
            }, {
                path: '/operationLog',
                name: 'operationLog',
                component: OperationLog
            }, {
                path: '/visitLog',
                name: 'visitLog',
                component: VisitLog
            }, {
                path: '/logonAccount',
                name: 'logonAccount',
                component: LogonAccount
            }, {
                path: '/',
                name: 'informationDefult',
                component: Information
            },
            // {
            //     path: '/bindingOtp',
            //     name: 'bindingOtp',
            //     component: BindingOtp
            // }
        ]
    }, {
        path: '/resetpassword',
        name: 'ResetPassword',
        component: ResetPassword
    }, {
        path: '/retrievePassword',
        name: 'RetrievePassword',
        component: RetrievePassword
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js